"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toReportable = toReportable;
const browser_1 = require("encamp-prisma/generated/browser");
const unitConversions_1 = require("encamp-shared/dist/units/unitConversions");
/**
 * Normalizes an accumulation amount into both kg and lb so fill events, the
 * facility cap, and the UI can all compare amounts recorded in different
 * units on a common basis. Mass units pass straight through the unit table.
 * Volume units — and barrels, which need a density even to convert to
 * another volume unit's mass equivalent — go through the specific gravity as
 * a pounds-per-gallon density. A non-positive or missing specific gravity
 * gives no valid density to convert with, so both fields come back null
 * instead of throwing.
 */
function toReportable(amount, unit, specificGravity) {
    if (!(0, unitConversions_1.canConvertWithoutDensity)(unit, browser_1.UnitType.KILOGRAMS)) {
        if (specificGravity === null || specificGravity <= 0) {
            return { kg: null, lb: null };
        }
        const densityLbPerGal = (0, unitConversions_1.convertSpecificGravityToPoundsPerGallonDensity)(specificGravity);
        return {
            kg: (0, unitConversions_1.convert)(amount, unit, browser_1.UnitType.KILOGRAMS, densityLbPerGal, browser_1.DensityUnits.POUNDS_PER_GALLON),
            lb: (0, unitConversions_1.convert)(amount, unit, browser_1.UnitType.POUNDS, densityLbPerGal, browser_1.DensityUnits.POUNDS_PER_GALLON),
        };
    }
    return {
        kg: (0, unitConversions_1.convert)(amount, unit, browser_1.UnitType.KILOGRAMS, null, null),
        lb: (0, unitConversions_1.convert)(amount, unit, browser_1.UnitType.POUNDS, null, null),
    };
}
//# sourceMappingURL=toReportable.js.map